<form [formGroup]="userForm" validateOnSubmit autocomplete="off">
  <div>
    <div class="row-fluid" style="margin-top: -28px">
      <br />

          <div class="col-sm-12" *ngIf="!editdata" [class.disabled]="disableUser">
            <label for="email"  class="mdc-text-field--fullwidth fids-line-ripple text-material mb-0" style="cursor: text; color: rgba(0, 0, 0, 0.6); font-weight: 400;">
             
              <ng-select [items]="people$ | async"
                         [placeholder]="'Email'"
                          [multiple]="false"
                         [closeOnSelect]="true"
                         bindLabel="mail"
                         formControlName="email"
                         (search)="getADUsers($event)"
                         (change)="onEmailSelect($event)"
                         (clear)="closeUserSearch()" 
                         id="emailList"
                         name="item"
                         [clearSearchOnAdd]="true"
                         #emailNgSelect >
                   <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span  style="color: rgba(0, 0, 0, 0.87);">{{ item.mail }}</span>
              </ng-template>
            </ng-select>
            
              <!-- <div class="mdc-line-ripple" style="position: relative;"></div> -->
            </label>      
          </div>
          <div class="col-sm-12 m-b-10 disabled" *ngIf="editdata" >
            <label class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material mb-0">
              <input matInput class="mdc-text-field__input input-aligner" type="text" maxlength="50" aria-label="Email"
                formControlName="email" disabled />
              <span class="mdc-floating-label">
                Email
              </span>
              <div class="mdc-line-ripple"></div>
            </label>
          </div>

      <div class="col-sm-12 m-b-10" *ngIf="!adSearchMode">
        <label class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material mb-0">
              <input matInput class="mdc-text-field__input input-aligner" type="text" maxlength="50" aria-label="First Name" formControlName="name" />
          <span class="mdc-floating-label minus-margin">
            First Name
          </span>
          <div class="mdc-line-ripple"></div>
        </label>
      </div>

      <div class="col-sm-12 m-b-10" *ngIf="!adSearchMode">
        <label class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material">
              <input matInput class="mdc-text-field__input input-aligner" type="text" maxlength="50" aria-label="Last Name" formControlName="surname"/>
          <span class="mdc-floating-label minus-margin">
            Last Name
          </span>
          <div class="mdc-line-ripple"></div>
        </label>
      </div>


      <!-- <div class="col-sm-12 m-b-10" *ngIf="!adSearchMode">
        <div class="fids-form-body">
          <label class="mdc-text-field fids-line-ripple text-material mb-0">
                <input class="mdc-text-field__input input-aligner input-validate-circle mat-aleft" type="text" aria-labelledby="phone-number-label-id" formControlName="phoneNumber" numericOnly />
            <div *ngIf="!userForm.controls.phoneNumber.valid && userForm.get('phoneNumber').touched">
              <em class="material-icons icon-image-preview error_background" id="invalid">error_outline</em>
              <span class="error_tooltip error_background error_fontsz" style="width: 65%">
                Please enter a valid phone number.
              </span>
            </div>
                <div *ngIf="userForm.controls.phoneNumber.valid && (userForm.controls.phoneNumber.value!=null && userForm.controls.phoneNumber.value!='')">
              <em class="material-icons icon-image-preview" id="valid">check_circle_outline</em>
                </div>
            <span class="mdc-floating-label minus-margin" id="phone-number-label-id">
              Phone Number
            </span>
            <div class="mdc-line-ripple"></div>
          </label>
        </div>
      </div> -->

      <div class="col-sm-12 m-b-10 m-t-10">
        <h6>Roles</h6>
        <label class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material">
          <input matInput class="mdc-text-field__input input-aligner" type="text" maxlength="50" aria-label="Search"
            (input)="onSearchChange($event)" />
          <span class="mdc-floating-label minus-margin">
            Search
          </span>
          <div class="mdc-line-ripple"></div>
        </label>
        <!-- Search Input -->
        <div class="slider-breaker"></div>
        <div class="scrollbar scrollableHz custom-scroll" style="max-height: 240px; float: none">
        <div *ngIf="filteredRoles?.length > 0; else noRoles">    
          <div *ngFor="let item of filteredRoles; let i = index">
                <div class="mdc-form-field" style="margin-top: 10px">
                  <div>
                    <!-- //NOSONAR --><div class="col-sm-12 pull-left"
                                       (click)="item.checked = !item.checked; onCheckChange(item.checked, item.id, item)" (keydown)="noop()">
                      <span *ngIf="item.checked == true" class="checkbox-item-font ey-dna-icon-Selected_Checkbox"></span>
                      <span *ngIf="item.checked == false" class="checkbox-item-font ey-dna-icon-Unselected_Checkbox"></span>
                    </div>
                  </div>
                  <div style="margin-top: -3px; text-transform: capitalize">
                    {{ item.name }}
                  </div>
                </div>
              </div>
        </div>
         <ng-template #noRoles>
            <div style="margin-top: 10px; text-align: center;">
              No role found
            </div>
		      </ng-template>
        </div>
      </div>

      <div class="col-sm-12 m-b-10 p-l-5">
        <div class="mdc-form-field formfield-material" [class.disabled]="!approveDisbaled"
          (click)="approve = !approve; onCheckChangeApprove(approve)" (keydown)="noop()">
          <div class="mdc-checkbox">
                <!-- //NOSONAR --><div class="col-sm-12 pull-left">
              <span *ngIf="approve" class="checkbox-item-font ey-dna-icon-Selected_Checkbox"></span>
              <span *ngIf="!approve" class="checkbox-item-font ey-dna-icon-Unselected_Checkbox"></span>
            </div>
          </div>
          <label style="padding-top: 5px; padding-left: 0px" for="checkbox-1">
            Approve
          </label>
        </div>
      </div>

    </div>
  </div>

  <div class="col-sm-12 m-b-10">
    <div class="row m-r-0 m-l-0">
      <div class="col pl-0">
        <button class="mdc-button ripple-material" (click)="close()" type="button">
          <span class="mdc-button__ripple"></span>
          Cancel
        </button>
            <button class="mdc-button fids-tooltip mdc-button--raised ml-3 mdc-button--sharp ripple-material" type="submit" (click)="validateBeforeSave()" [disabled]="!userForm.valid || (this.userForm.value.selectedRoleIds && this.userForm.value.selectedRoleIds.length == 0)">
          <span class="mdc-button__ripple"></span>
          Submit
        </button>

      </div>
    </div>
  </div>

</form>